/* eslint no-mixed-operators: "off" */

export const isImageLoaded = (state, props) =>
  state
  && props
  && state.asyncImages
  && props.src
  && state.asyncImages[props.src]
  || false



// WEBPACK FOOTER //
// ./src/asyncImages/selectors.js